import pb from "../../../lib/pocketbase";
import Container from "../../../components/Container";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";
import { IInboxRecord } from "../../../lib/types";
import Button, { buttonClasses } from "../../../components/form/button";
import { useToast } from "../../../components/ui/use-toast";
import BackButton from "../../../components/form/BackButton";
export default function InboxItem() {
    const id = useParams().id;
    const [message, setMessage] = useState<IInboxRecord>();
    const navigate = useNavigate();
    const { toast } = useToast();

    async function load() {
        if (!!id) {
            let inbox: IInboxRecord = await pb.collection("inbox").getOne(id);
            if (!inbox.read) {
                inbox = await pb.collection("inbox").update(inbox.id, { read: true });
            }
            setMessage(inbox);
        }
    }
    useEffect(() => {
        if (!pb.authStore.isValid) {
            navigate("/studio/login");
        }
        if (pb.authStore?.model?.role < 1) {
            navigate(-1);
        }
        load();
    }, []);

    async function markAsUnread() {
        if (message) {
            const updated: IInboxRecord = await pb.collection("inbox").update(message.id, { read: false });
            setMessage(updated);
            toast({
                title: "👍 marked as unread"
            });
        }
    }
    async function toggleArchive(state: boolean) {
        if (message) {
            const updated: IInboxRecord = await pb.collection("inbox").update(message.id, { archived: state });
            setMessage(updated);
            toast({
                title: `👍 marked as ${state ? "archived" : "unarchived"}`
            });
        }
    }
    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Inbox</title>
            </Helmet>
            <Container className="mb-8 mt-4 md:mt-8 lg:mt-16">
                <BackButton className="mb-4" />
                {message && (
                    <>
                        <div className="flex items-center justify-between">
                            <h2 className="text-3xl font-bold">{message.subject}</h2>
                            <Button size={"small"} onClick={() => toggleArchive(!message.archived)}>
                                {message.archived ? "Unarchive" : "Archive"}
                            </Button>
                        </div>
                        <h3 className="text-sm italic">from {message.email}</h3>
                        <div className="mt-8 rounded-lg bg-slate-100 p-4 dark:bg-slate-800 md:p-8" dangerouslySetInnerHTML={{ __html: message.message }}></div>
                        <div className="mt-8 flex items-center gap-2">
                            <a href={`mailto:${message.email}`} className={buttonClasses({ variant: "dark" })}>
                                Reply
                            </a>
                            {message.read && <Button onClick={() => markAsUnread()}>Mark as unread</Button>}
                        </div>
                    </>
                )}
            </Container>
        </>
    );
}
